import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
export const Spinner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={clsx("w-3", "h-3", "border-2", "border-white", "border-t-transparent", "rounded-full", "animate-spin")} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};